import React, { useRef } from "react";
import { useIntl } from "react-intl";
import { useAgentId, useModal } from "@/hook";
import { useAgentSummary, useTraining } from "@/query/deployment";
import Button from "@/component/Button";
import { Modal } from "@/component/modal";


export const DEPLOYMENT_TRAINING_MODAL_ID = "deployment-training-modal-id";

const DeploymentTrainingModal: React.FC = () => {
    const intl = useIntl();
    const modal = useModal();
    const agentId = useAgentId();

    const descriptionRef = useRef<HTMLTextAreaElement>(null);

    const { mutateAsync: train, isPending: isTraining } = useTraining(agentId);
    const { data: summary } = useAgentSummary(agentId);

    const onClickCancel = () => {
        modal.close(DEPLOYMENT_TRAINING_MODAL_ID);
    };

    const onClickConfirm = async () => {
        const checkout = !!(summary && parseInt(summary.sandbox_version.version) > 0);
        await train({
            checkout,
            description: descriptionRef.current?.value
        }).then(() => {
            modal.close(DEPLOYMENT_TRAINING_MODAL_ID);
        });
    };

    return (
        <Modal id={DEPLOYMENT_TRAINING_MODAL_ID}
               size="md"
               title={intl.formatMessage({ id: "i10002" })}
        >
            <div className="modal-body">
                <div className="modal-description">
                    {intl.formatMessage({ id: "i10007" })}
                </div>
                <div className="flex flex-col gap-1.5">
                    <div className="input-group-heading">
                        {intl.formatMessage({ id: "i10034" })}
                    </div>
                    <textarea ref={descriptionRef}
                              rows={4}
                              className="modal-input"
                              placeholder={intl.formatMessage({ id: "i10035" })}
                    />
                </div>
                <div className="modal-btn-group">
                    <Button variant="secondary"
                            size="sm"
                            onClick={onClickCancel}
                    >
                        {intl.formatMessage({ id: "b0002" })}
                    </Button>
                    <Button variant="primary"
                            size="sm"
                            disabled={isTraining}
                            onClick={onClickConfirm}
                    >
                        {intl.formatMessage({ id: "b0001" })}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DeploymentTrainingModal;
